export default "__VITE_ASSET__153sqYYz__"